(function () {
  if (!window.matchMedia('(min-width: 768px) and (hover: hover)').matches) return;

  function init() {
    var form = document.querySelector('.product-single__meta form.product-form');
    var buyButton = form && form.querySelector('[data-all-product-buy-now]');
    var addButton = form && form.querySelector('button[name="add"]');
    var error = form && form.querySelector('[data-all-product-buy-error]');
    if (!form || !buyButton || !addButton) return;

    var cartLink = document.querySelector('header #HeaderCart');
    if (cartLink && !document.querySelector('.smile-pro-shop-now')) {
      var shopNow = document.createElement('a');
      shopNow.className = 'smile-pro-shop-now';
      shopNow.href = '/collections/all-products';
      shopNow.innerHTML = '<span>Shop Now</span><span class="smile-pro-shop-now__arrow" aria-hidden="true">→</span>';
      cartLink.parentNode.insertBefore(shopNow, cartLink);
    }
    if (cartLink) {
      var cartIcon = cartLink.querySelector('svg');
      if (cartIcon) {
        cartIcon.outerHTML = '<svg class="smile-pro-header-cart-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M2 3h2l2.2 12.5h12.6L21 7H5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="8" cy="20" r="1" fill="currentColor"/><circle cx="18" cy="20" r="1" fill="currentColor"/></svg>';
      }
    }

    function syncAvailability() {
      buyButton.disabled = addButton.disabled || addButton.getAttribute('aria-disabled') === 'true';
    }
    syncAvailability();
    form.addEventListener('change', syncAvailability);
    window.addEventListener('pageshow', function (event) { if (event.persisted) syncAvailability(); });
    new MutationObserver(syncAvailability).observe(addButton, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled']
    });

    buyButton.addEventListener('click', async function () {
      if (buyButton.disabled) return;

      var data = new FormData(form);
      var variantId = Number(data.get('id'));
      var quantity = Math.max(1, Number(data.get('quantity')) || 1);
      if (!variantId) {
        if (error) {
          error.textContent = 'Please select an available option.';
          error.hidden = false;
        }
        return;
      }

      buyButton.disabled = true;
      if (error) error.hidden = true;
      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
        });
        if (!response.ok) {
          var details = await response.json();
          throw new Error(details.description || 'Unable to add this item. Please try again.');
        }
        window.location.assign('/checkout');
      } catch (failure) {
        if (error) {
          error.textContent = failure.message || 'Unable to continue. Please try again.';
          error.hidden = false;
        }
        syncAvailability();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
